import type { DataStructureCommon, DataStructureComponent } from 'types';

export const dataCommonToComponent = (data: DataStructureCommon): DataStructureComponent => ({
  id: data.id || data.identifier,
  identifier: data.identifier,
  label: data.label,
  isSelected: Boolean(data.selected),
  isDisabled: false,
  isFocused: false,
  value: String(data.value)
});

export const dataComponentToCommon = (data: DataStructureComponent): DataStructureCommon => ({
  id: data.id,
  identifier: data.identifier,
  label: data.label,
  value: data.value,
  selected: data.isSelected
});

export const dataGetCommonStructure = (
  identifier: string,
  label: string | undefined,
  value: string | number,
  selected: boolean
): DataStructureCommon => ({
  id: identifier,
  identifier,
  label,
  value,
  selected
});
